
import React from 'react';
import { Button } from '@/components/ui/button';
import { Mail } from 'lucide-react';

interface SuccessMessageProps {
  handleResendEmail: () => Promise<void>;
  resendLoading: boolean;
  switchToSignIn: () => void;
}

const SuccessMessage: React.FC<SuccessMessageProps> = ({ 
  handleResendEmail, 
  resendLoading, 
  switchToSignIn 
}) => {
  return (
    <div className="text-center space-y-4">
      <div className="bg-green-50 dark:bg-green-900/20 p-4 rounded-lg">
        <div className="flex justify-center mb-2">
          <Mail className="h-6 w-6 text-green-600 dark:text-green-400" />
        </div>
        <h3 className="font-medium text-green-800 dark:text-green-300">Verification Email Sent</h3>
        <p className="text-green-700 dark:text-green-400 mt-2">
          Please check your email for a verification link to complete your signup.
        </p>
      </div>
      <div className="space-y-3">
        <Button 
          onClick={handleResendEmail}
          variant="outline"
          disabled={resendLoading}
          className="w-full"
        >
          {resendLoading ? "Sending..." : "Resend Verification Email"}
        </Button>
        <Button 
          type="button"
          onClick={switchToSignIn}
          variant="ghost"
          className="w-full"
        >
          Back to Sign In
        </Button>
      </div>
    </div>
  );
};

export default SuccessMessage;
